export default __webpack_public_path__ + "static/testimonial-2cf27b4a4a6e2b9b4e0137108dde1021.jpg";